import { render, staticRenderFns } from "./advertPage.vue?vue&type=template&id=4606dc2b&scoped=true&"
import script from "./advertPage.vue?vue&type=script&lang=ts&"
export * from "./advertPage.vue?vue&type=script&lang=ts&"
import style0 from "./advertPage.vue?vue&type=style&index=0&id=4606dc2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4606dc2b",
  null
  
)

export default component.exports